<template>
  <div class="password-reset container">
    <div class="login-wrapper mx-auto mt-sm-5 pt-4 p-sm-4">

      <div v-if="!success">
        <div class="row py-3">
          <div class="col-12 col-md-7 px-1 px-md-3 pb-5 pb-md-0">
            <div class="py-lg-1">
             <div>
               <p>Mы отправим вам SMS сообщение с паролем. Если вы не зарегистрированы в
                личном кабинете, пожалуйста, обратитесь в службу поддержки.
              </p>
                <div class="pt-3">
                 <div class="font-weight-light">
                   <h5>Служба поддержки</h5>
                 </div>
                 <div>
                    Тел (бесплатный):
                    <a class="border-bottom font-weight-bold" href="tel:88007750808">
                      8 (800) 775-08-08</a>
                 </div>
<!--                 <div class="">-->
<!--                   Тел (городской):-->
<!--                   <a class="border-bottom font-weight-bold" href="tel:+78617752808">-->
<!--                     + 7 (861) 775-28-08</a>-->
<!--                 </div>-->
                 <div class="row">
                   <div class="col-10 col-lg-9 pr-0">
                     Тел (мегафон):
                     <a class="border-bottom font-weight-bold" href="tel:+79687750808">
                       + 7 (968) 775-08-08
                     </a>
                   </div>
                   <div class="col-1 px-0 px-md-2">
                     <font-awesome-icon :icon="['fab', 'whatsapp']" />
                   </div>
                   <div class="col-1 px-0 px-lg-0">
                     <font-awesome-icon :icon="['fab', 'telegram']" />
                   </div>
                 </div>
                </div>
             </div>
            </div>
          </div>
          <div class="col-12 col-md-5">
            <div class="font-weight-light pb-2">
              <h5>Получить новый пароль</h5>
            </div>
            <form name="form" @submit.prevent="resetAccountPassword" autocomplete="off">
              <div class="row contact-block">
                <div class="col-10">
                  <div class="form-group">
                    <input type="tel" v-mask="['+7 (###) ###-##-##', '+7 (###) ###-##-##']"
                           required class="form-control" id="username" v-model="contactPhone"
                           @focusin="InputFocusIn('username')"
                           @focusout="InputFocusOut('username')" />
                    <label for="username">Ваш номер телефона</label>
                  </div>
                </div>
                <div class="col-2 pt-4">
                 <v-popover offset="26" placement="left">
                   <font-awesome-icon class="tooltip-target b3" :icon="['fa', 'info-circle']" />
                   <template slot="popover">
                     Номер телефона, который указывался Вами при регистрации и на который
                     должно приходить напоминание об оплате.
                   </template>
                 </v-popover>
               </div>
              </div>
              <div class="form-group pt-3">
                <button type="submit" class="btn btn-primary">Отправить пароль</button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div v-else class="text-center">
        <p>Новый пароль будет отправлен пользователю, если такой пользователь существует.</p>
        <router-link to="/">На главную</router-link>
      </div>

    </div>
  </div>
</template>

<script>
import auth from '../../api/auth';

export default {
  name: 'password-reset',
  data() {
    return {
      contactPhone: '',
      success: false,
    };
  },
  methods: {
    resetAccountPassword() {
      auth.resetAccountPassword(this.contactPhone)
        .then(() => { this.success = true; });
    },
  },
};
</script>
